export default "__VITE_ASSET__THJNpwEr__"